import React, {useState, useCallback, useEffect} from 'react';
import { useDropzone } from 'react-dropzone';
import "./image-file-upload.css"

const ImageFileUpload = ({ multiple = false, onChange }) => {
    const [files, setFiles] = useState([]);

    useEffect(()=>{
        onChange(files);
    },[files])
    // When files are dropped, this callback handles them.
    const onDrop = useCallback((acceptedFiles) => {
        // Map through the files and set a preview URL for each image
        if (multiple) {
            setFiles((prevFiles) => [
                ...prevFiles,
                ...acceptedFiles.map((file) =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                    })
                ),
            ]);
        } else {
            setFiles(
                acceptedFiles.map((file) =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                    })
                )
            );
        }
    }, [multiple]);

    // Remove the file by filtering it out from the state
    const removeFile = (fileName) => {
        setFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
    };

    // Only render image previews
    const renderPreview = (file) => {
        return <img src={file.preview} alt={file.name} />;
    };

    // Dropzone setup: Accept only image files and allow multiple file upload
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: ['image/*'], // Accept only image files
        multiple, // Whether multiple files are allowed
    });

    return (
        <div>
            <div
                {...getRootProps()}
                className={'image-file-upload-container'}
            >
                <input {...getInputProps()} />
                {isDragActive ? (
                    <p>عکس های انتخاب شده را اینجا رها کنید</p>
                ) : (
                    <p>
                        عکس های مورد نظر خود را در این باکس بیاندازید یا از اینجا عکس های خود را انتخاب کنید
                        {multiple ? '' : ' (1 image only)'}.
                    </p>
                )}
            </div>

            {files.length > 0 && (
                <div style={{ marginTop: '20px' }}>
                    <ul className={"image-file-upload-container-ul"}>
                        {files.map((file, index) => (
                            <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                {renderPreview(file)}
                                <button
                                    onClick={() => removeFile(file.name)}
                                >
                                    حذف
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default ImageFileUpload;
